import Component from '../abstracts/Component';


/**
 Login component
 */
export default class PreventCharPasteInNumberFieldsComponent extends Component {

  get SELECTORS() {
    return {
      numberInputFields: "input[type='number']"
    };
  }

  constructor() {
    super();
  }

  render() {


    const {numberInputFields} = this.SELECTORS;

    $(document).on("paste",numberInputFields, (e)=> {
      const clipboardData = e.originalEvent.clipboardData || window.clipboardData;
      //match a char which isn't a number
      if (clipboardData.getData('text').match(/[^\d]/))
        e.preventDefault(); //prevent the default behaviour
    })
    .on("keypress",numberInputFields, function (e) {
      const keyCode = e.keyCode;
      if (keyCode !== 8 && keyCode !== 0 && keyCode < 48 || keyCode > 57)
        e.preventDefault();
    }).on('input',numberInputFields,function(e){
      const input=$(this);
      const data=e.originalEvent.data;
      if(data==="" || data==="."){
        input.val("");
      }
    });
  }

}
